<template>
    <div>
        <b-form>
            <!-- <span>Pilih Angkatan </span> -->
            <Select2 v-model="selectedValue" :options="options" @change="changegeneration($event)"
                :placeholder="placeholder" :settings="{ multiple: false, width: '100%' }" />
        </b-form>
    </div>
</template>

<script>
import axios from "axios"
export default {
    data() {
        return {
            selected: null,
            options: [
                { value: null, text: '--Pilih Tahun Akademik--' },
                // { value: '60', text: '60' },
                // { value: '61', text: '61' },
                // { value: '62', text: '62' }
            ]
        }
    },
    props: {
        placeholder: String,
        changegeneration: Function,
        selectedValue: String,
    },
    async mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            await axios.get('master/generations')
                .then(response => {
                    if (response.status == 200) {
                        response.data.data.some((e, index) => {
                            if(e.status == true) {
                                var object = { "id": e.key, "text": e.tahun + " / " + e.tahun_akhir + " " + e.semester }
                                // var object = { "id": e.key, "text": e.tahun + " " + e.semester }
                                this.options.push(object);
                            }
                            return index > e.length;
                        });
                    }
                })
        },
    },
}
</script>